import Immutable, { Record, List } from 'immutable';
import Category from './Category';
import Activity from './Activity';

const CoveredInClassRecord = Record({
  lessonNumber: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  cicStatus: undefined,
  cicCategories: new List(),
  cicActivities: new List(),
});

class CoveredInClass extends CoveredInClassRecord { }

const receiver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'cicStatus':
      return [key, `${val}`];
    case 'cicActivities':
      return [key, new List(val.map(Activity.create))];
    case 'cicCategories':
      return [key, new List(val.map(Category.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};


CoveredInClass.create = (data) =>
  new CoveredInClass(data).mapEntries(receiver);

export default CoveredInClass;



// WEBPACK FOOTER //
// ./data/CoveredInClass/model.js